import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-night-900 font-dm-sans" data-id="element-304">
      <HeroSection data-id="element-305" />
      <ProblemSection data-id="element-306" />
      <MethodSection data-id="element-307" />
      <OfferSection data-id="element-308" />
      <FAQSection data-id="element-309" />
      <CTASection data-id="element-310" />
      <Footer data-id="element-311" />
    </div>;
}